<script>
    import * as ze from "@axel669/zephyr"

    import ItemInfo from "./item-info.svelte"

    let {
        item = $bindable(),
        bag,
    } = $props()

    const { close } = ze.modalContext()
    const removeItem = (rem) => {
        if (rem === false) {
            return
        }
        close(item)
    }
</script>

<ze.Dialog w="min(70vw, 320px)" card>
    {#snippet header()}
        <ze.Titlebar>
            {#snippet title()}
                <ze.Text title>
                    Edit Item
                    <ze.Text subtitle>
                        In: {bag.name}
                    </ze.Text>
                </ze.Text>
            {/snippet}

            {#snippet action()}
                <ze.EntryButton onentry={removeItem} color="@danger">
                    <ze.Icon name="trash" t.sz="20px" />
                    {#snippet modal()}
                        <ze.Confirm
                            title="Delete Item"
                            message="Do you want to delete {item.name} in {bag.name}?"
                            okText="Delete"
                            w="60vw"
                        />
                    {/snippet}
                </ze.EntryButton>
            {/snippet}
        </ze.Titlebar>
    {/snippet}

    <ItemInfo bind:item />

    {#snippet footer()}
        <ze.Grid cols="1fr">
            <ze.Button flat color="@primary" onclick={() => close(null)}>
                Close
            </ze.Button>
        </ze.Grid>
    {/snippet}
</ze.Dialog>
